<template>
  <b-container style="margin-left: 5px" id="pdfQuestions">
    <b-row>
      <b-col sm="10">
        <ckeditor :style="getPageTitleColor(pageAccentColor)" :editor="editor" v-model="pageName" :config="editorConfig"
                  @input="setNameSaveable"></ckeditor>
      </b-col>
      <b-col sm="2">
        <b-col sm="2">
          <b-button id="saveButton" @click="savePageName" :disabled="savePageNameButtonEnable" :variant="saveButtonVariant">
            Save
          </b-button>
        </b-col>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="10">
        <ckeditor :editor="editor" v-model="text" :config="editorConfig" @input="setSaveable"></ckeditor>
      </b-col>
      <b-col sm="2">
        <b-col sm="2">
          <b-button id="saveButton" @click="saveChanges" :disabled="saveButtonEnable" :variant="saveButtonVariant">
            Save
          </b-button>
        </b-col>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" style="padding-right: 0;">
        <div style="display:flex; width: 100%; padding: 0 15px 0 0;">
          <div id="core-title-bar" class="survey-title" style="padding-top: 0; padding-bottom: 0; flex: 1">
            <div class='core_measure_header' :style="`background-color:${pageAccentColor}`" v-if="inputPage">
              <h3 style='margin-left: 5px;'>CORE MEASURES</h3>
            </div>
          </div>
          <div :style="`width 10%; float: right; margin-bottom: 8px; padding-bottom: 0; padding-top: 5px;
        padding-left: 0; padding-right: 5px; vertical-align: top; background-color:${pageAccentColor}`"
               v-if="inputPage">
            <font-awesome-icon id="addCoreQuestionIcon" icon="plus-circle" size="1x" @click="addQuestion('core')"
                               title="Add Question To Section" :style="getContrastColor(pageAccentColor)"/>
          </div>
        </div>
      </b-col>
    </b-row>
    <draggable
        @start="drag=true" :list="coreQuestions"
        style="width: 100%; margin-bottom: 5px"
        group="coreQuestions"
        @end="onEnd" handle=".handle">
      <VineyardQuestionEditor v-for="question in coreQuestions" :key="question._id" :q-value="question"
                              :response="answers[question._id]" :num="question.qnum"></VineyardQuestionEditor>
    </draggable>
    <div id="elective-title-bar" class="survey-title">
      <div class='core_measure_header' :style="`background-color:${pageAccentColor}`" v-if="inputPage">
        <b-row>
          <b-col cols="4"><h3 style='margin-left: 5px;'>ELECTIVE MEASURES (</h3></b-col>
          <b-col cols="1">
            <b-form-input @change="setElectiveSaveable"
                          style="color: black;margin-top: 2px; margin-bottom: 2px; display: inline-block"
                          v-model="requiredElective">
            </b-form-input>
          </b-col>
          <b-col cols="3"><h3>{{ " of " + electiveQuestions.length }} Required)</h3>
          </b-col>

            <b-col sm="2">
              <b-button id="saveElectiveButton" @click="saveElectiveChanges" :disabled="saveElectiveButtonEnable"
                        :variant="saveElectiveButtonVariant">
                Save
              </b-button>
            </b-col>

          <b-col cols="2">
            <b-col>
              <b-row>
                <div style="width: 80%;"></div>
                <div :style="`width 10%; float: right; margin-bottom: 8px; padding-bottom: 0; padding-top: 5px;
        padding-left: 0; padding-right: 5px; vertical-align: top; background-color:${pageAccentColor}`">
                  <font-awesome-icon id="addCoreQuestionIcon" icon="plus-circle" size="1x"
                                     @click="addQuestion('elective')"
                                     title="Add Question To Section" :style="getContrastColor(pageAccentColor)"/>
                </div>
              </b-row>
            </b-col>
          </b-col>
        </b-row>
      </div>
    </div>
    <draggable
        @start="drag=true" :list="electiveQuestions"
        style="width: 100%; margin-bottom: 5px"
        group="electiveQuestions"
        @end="onEnd" handle=".handle">
      <VineyardQuestionEditor v-for="question in electiveQuestions" :key="question._id" :q-value="question"
                              :response="answers[question._id]" :num="question.qnum"></VineyardQuestionEditor>
    </draggable>
    <div id="comments-title-bar" class="survey-title">
      <VineyardQuestionEditor :key="`${pageId}-comment`" v-if="inputPage"
                              :q-value="{qnum:'*', text:'Comments', controlType: 'COMMENT', _id : pageId+'Comment'}"
                              :response="getCommentResponse"></VineyardQuestionEditor>
    </div>
    <div style="margin-top: 20px; margin-left: auto"></div>
    <Modal v-model="showFirstModal" title="Select Question To Add"
           :modal-style="{ 'max-width': '1000px' }">
      <form novalidate>
        <b-form-group label-for="pageSelection" label="Question Page">
          <b-form-select id="pageSelection" v-model="selectedPage"
                         :options="pages"
                         value-field="_id"
                         text-field="name">
          </b-form-select>
        </b-form-group>
        <b-container v-if="questionToAdd" fluid="true" style="margin:20px; max-width: 1000px;"
                     :id="`modalQuestionId-${questionToAdd._id}`">
          <b-row>
            <b-col :id="`modalQtext`" sm="12" style="font-size: x-large;"><span
                class="modal-question-number">{{ questionToAdd.qnum }}.</span><span
                class="modal-question-text" v-html="questionToAdd.text"></span></b-col>
          </b-row>
          <b-row v-if="questionToAdd.greenNote && questionToAdd.greenNote.length > 0">
            <b-col cols="2" id="greenNote" class="green-note-label text-right align-top">Green Note:</b-col>
            <b-col class="green-note align-top" cols="9"><span v-html="`${questionToAdd.greenNote}`"></span></b-col>
          </b-row>
          <b-row v-if="questionToAdd.controlType === 'MATRIX'">
            <b-col style="text-align: center; width: 100%;">
              <b-form-radio-group
                  v-model="questionToAdd.selectedResponse">
                <b-form-radio :style="getModalRadioStyle(options)"
                              v-for="option in questionToAdd.columns"
                              :key="option"
                              :value="option"
                              name="flavour-3a"
                              size="lg">
                  <span style="font-size: 20px; margin: 0 100px 0 10px;">{{ option }} </span>
                </b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row v-else-if="questionToAdd.controlType === 'CHECKBOX'">
            <b-col style="text-align: left; width: 100%; padding-left: 40px; font-size: large">
              <b-form-group>
                <b-form-checkbox-group
                    :id="`checkbox-group-${id}`"
                    :options="choices"
                    name="flavour-1"
                    size="lg"
                    stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else-if="questionToAdd.controlType === 'COMMENT'">
            <b-col style="text-align: center; width: 100%; font-size: large">
              <b-form-group>
                <b-textarea></b-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
        <div class="row modal-footer">
          <div class="col-sm-12">
            <div class="float-right">
              <button class="btn btn-primary" type="button" @click="addQuestionsToList">Ok</button>
              <b-button class="btn btn-secondary ml-2" type="button" @click="closeModal">Cancel</b-button>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  </b-container>
</template>
<script>
import Bus from "@/eventBus";
import Draggable from 'vuedraggable';
import InlineEditor from "@ckeditor/ckeditor5-editor-inline/src/inlineeditor";
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import VineyardQuestionEditor from "@/components/vineyard/editor/VineyardQuestionEditor";
import BlockQuotePlugin from '@ckeditor/ckeditor5-block-quote/src/blockquote';

import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties';
import Image from '@ckeditor/ckeditor5-image/src/image.js';
import ListPlugin from '@ckeditor/ckeditor5-list/src/list.js';
import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed.js';
import ImageInsert from '@ckeditor/ckeditor5-image/src/imageinsert.js';
import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor.js';
import Table from '@ckeditor/ckeditor5-table/src/table.js';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';
import TodoList from '@ckeditor/ckeditor5-list/src/todolist';
import CKEditor from "@ckeditor/ckeditor5-vue2";
import VueModal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import VineyardQuestion from "@/components/vineyard/questions/VineyardQuestion";
import {ColorUtils} from "@/color-contrast";

export default {
  name: 'VineyardSurveyPageEditor',
  components: {
    Draggable,
    VineyardQuestionEditor,
    'ckeditor': CKEditor.component,
    'Modal': VueModal,
    VineyardQuestion
  },
  props: {
    pageId: String,
    answers: {}
  },
  data() {
    return {
      coreQuestions: [],
      electiveQuestions: [],
      commentsText: "",
      pageName: "SOCIAL EQUITY JUSTICE & INCLUSION",
      answersList: this.answers,
      text: "",
      inputPage: false,
      pageBackgroundColor: 'rgb(248, 248, 248)',
      pageAccentColor: 'blue',
      requiredElective: 0,
      editorConfig: {
        link: {
          decorators: {
            addTargetToExternalLinks: true,
            toggleDownloadable: {
              mode: 'manual',
              label: 'Downloadable',
              attributes: {
                download: 'file'
              }
            },
            openInNewTab: {
              mode: 'manual',
              label: 'Open in a new tab',
              defaultValue: true,			// This option will be selected by default.
              attributes: {
                target: '_blank',
                rel: 'noopener noreferrer'
              }
            }
          }
        },
        readOnly: true,
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          ListPlugin,
          HtmlEmbed,
          BlockQuotePlugin,
          Table,
          TableToolbar,
          TableProperties,
          Image,
          ImageInsert,
          TodoList,
          FontBackgroundColor,
          FontColor
        ],
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'fontColor',
            'fontBackgroundColor',
            'paragraph',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'imageInsert',
            'htmlEmbed',
            'blockQuote',
            'horizontalLine',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
            'image',
            'todoList',
            'tableProperties',
            'tableCellProperties'
          ]
        },
        language: 'en',
        image: {
          toolbar: [
            'imageTextAlternative',
            'imageStyle:full',
            'imageStyle:side'
          ]
        },
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
          ]
        },
        fontColor: {
          colors: [
            {
              color: 'hsl(0, 0%, 0%)',
              label: 'Black'
            },
            {
              color: 'hsl(0, 0%, 30%)',
              label: 'Dim grey'
            },
            {
              color: 'hsl(0, 0%, 60%)',
              label: 'Grey'
            },
            {
              color: 'hsl(0, 0%, 90%)',
              label: 'Light grey'
            },
            {
              color: 'hsl(0, 0%, 100%)',
              label: 'White',
              hasBorder: true
            },
            {
              color: 'hsl(0, 75%, 60%)',
              label: 'Red'
            },
            {
              color: 'hsl(30, 75%, 60%)',
              label: 'Orange'
            },
            {
              color: 'hsl(60, 75%, 60%)',
              label: 'Yellow'
            },
            {
              color: 'hsl(90, 75%, 60%)',
              label: 'Light green'
            },
            {
              color: 'hsl(120, 75%, 60%)',
              label: 'Green'
            },
            {
              label: "NAPA GREEN VINEYARD-INTRODUCTION",
              color: '#28763a'
            },
            {
              label: "SOCIAL EQUITY, JUSTICE AND INCLUSION",
              color: '#3b5152'
            },
            {
              label: "IRRIGATION ASSESSMENTS & WATER EFFICIENCY",
              color: "#1F497D"
            },
            {
              label: "TREE/FOREST PRESERVATION & ENHANCEMENT",
              color: "rgb(167, 170, 97)"
            },
            {
              label: "PROHIBITED & RESTRICTED PESTICIDES LIST",
              color: "#851527"
            },
            {
              label: "CONSERVATION BURNING & BURN ALTERNATIVES",
              color: "rgb(222, 119, 43)"
            }
          ],
          columns: 6
        }
      },
      editor: InlineEditor,
      saveButtonEnable: true,
      savePageNameButtonEnable: true,
      saveButtonVariant: "outline-primary",
      savePageNameButtonVariant: "outline-primary",
      saveElectiveButtonEnable: true,
      saveElectiveButtonVariant: "outline-primary",
      isMounted: 0,
      showFirstModal: false,
      selectedPage: null,
      pages: [{value: null, text: 'Please select an Page'}],
      questionTypeToAdd: null,
      modalClass: 'modal-xl'
    }
  },
  beforeMount() {
    let self = this;
    this.$http.get(`vineyard/survey/page/${this.pageId}`)
        .then(result => {
          let checklistPage = result.data;
          self.text = checklistPage.verbiage;
          self.coreQuestions = checklistPage.coreQuestions;
          self.electiveQuestions = checklistPage.electiveQuestions;
          self.commentsText = this.answers[`${this.pageId}Comment`];
          self.inputPage = checklistPage.inputPage;
          self.pageName = checklistPage.name;
          self.requiredElective = checklistPage.requiredElective;
          self.pageBackgroundColor = checklistPage.pageBackgroundColor || self.pageBackgroundColor;
          self.pageAccentColor = checklistPage.pageAccentColor;
          console.log("Changing Background Color To: " + self.pageBackgroundColor);
          Bus.$emit('vineyard-page-background-update', self.pageBackgroundColor);
          /****************************************************/
          if (this.$route.query.debug === "true") {
            console.log("Answers List");
            console.log(this.answersList);
            if (this.coreQuestions.length > 0) {
              console.log("Core Questions");
              console.log(this.coreQuestions[0])
              console.log(this.answersList[this.coreQuestions[0]._id]);
            }
            console.log(this.commentsText);
            console.log("Input Page: " + this.inputPage);
          }
        })
        .catch(error => {
          console.log(error)
        });
  },
  created() {
    Bus.$on('delete-question', this.deleteQuestion);
  },
  beforeDestroy() {
    Bus.$off('delete-question', this.deleteQuestion);
  },
  watch: {
    pageId: function (val) {
      let self = this;
      this.$http.get(`vineyard/survey/page/${this.pageId}`)
          .then(result => {
            console.log(`Page Id: ${val}`);

            let page = result.data;
            self.text = page.verbiage;
            self.electiveQuestions = page.electiveQuestions;
            self.coreQuestions = page.coreQuestions;
            self.commentsText = page.commentsText;
            self.inputPage = page.inputPage;
            self.pageName = page.name;
            self.requiredElective = page.requiredElective;
            self.pageBackgroundColor = page.pageBackgroundColor || self.pageBackgroundColor;
            self.pageAccentColor = page.pageAccentColor;
            console.log("Changing Background Color To: " + self.pageBackgroundColor);
            Bus.$emit('vineyard-page-background-update', self.pageBackgroundColor);
          })
          .catch(error => {
            console.log("Error: " + error.message);
          })
      console.log("Updating commentsText");
      self.commentsText = this.answers[`${this.pageId}Comment`];
    }
  },
  computed: {
    getCommentResponse() {
      return this.answers[this.pageId + 'Comment'];
    },
    questionToAdd() {
      let name = this.pages.find(page => {
        return page._id === this.selectedPage
      });
      console.log("Question Text: " + (name ? name.text : name));
      return name;
    }
  },
  methods: {
    onEnd: function (evt) {
      let self = this;
      console.log("End Draggable Move")
      this.coreQuestions.forEach(quest => {
        let questIndex = self.coreQuestions.indexOf(quest);
        quest.qnum = questIndex + 1;
        console.log(quest);
        self.$set(self.coreQuestions, questIndex, quest);
      });

      this.electiveQuestions.forEach(this.updateQuestionNumbers);
      this.updateQuestionsOnServer();
      return false;
    },
    updateQuestionsOnServer() {
      let questionsMap = {
        CORE: this.coreQuestions,
        ELECTIVE: this.electiveQuestions
      };
      this.$http.put(`vineyard/survey/page/${this.pageId}/questions`, questionsMap, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(result => {
            if (result.status === 200) {
              if (result.data) {
                this.$toasted.info("Questions Order Updated Successfully", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-save',
                    after: false
                  }
                })
                    .goAway(5000);
              } else {
                this.$toasted.info("Question Order Save Failed", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-skull-crossbones',
                    after: false
                  }
                })
                    .goAway(5000);
              }

            }
          })
          .catch(error => {
            console.log(error)
          });

    },
    updateQuestionNumbers: function (quest) {
      let questIndex = this.electiveQuestions.indexOf(quest);
      if (quest.questionType === "COMMENT") {
        quest.qnum = 0;
      } else {
        quest.qnum = questIndex + 1;
      }
      this.$set(this.electiveQuestions, questIndex, quest);
    },
    getPageTitleColor: function (pageAccentColor) {
      return `color: ${pageAccentColor}; margin-left: 5px;font-size: 32px;font-family: Montserrat, sans-serif;text-transform: capitalize;`;
    },
    reportCommentValue: function (event) {
      console.log(event);
      Bus.$emit('measure-answer-update', this.pageId + "Comment", document.getElementById(this.pageId + "-comment").value);
    },
    saveChanges: function () {
      let verbiage = this.text;
      this.$http.put(`vineyard/survey/page/${this.pageId}`, verbiage, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(result => {
            if (result.status === 202) {
              if (result.data) {
                this.$toasted.info("Verbiage Saved Successfully", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-save',
                    after: false
                  }
                })
                    .goAway(5000);
              } else {
                this.$toasted.info("Verbiage Save Failed", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-skull-crossbones',
                    after: false
                  }
                })
                    .goAway(5000);
              }

            }
          })
          .catch(error => {
            console.log(error)
          });

      this.saveButtonEnable = true;
      this.saveButtonVariant = "outline-primary";
    },
    savePageName: function () {
      let pageName = this.pageName;
      this.$http.put(`vineyard/survey/page/${this.pageId}/name`, pageName, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(result => {
            if (result.status === 202) {
              if (result.data) {
                this.$toasted.info("Page Name Saved Successfully", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-save',
                    after: false
                  }
                })
                    .goAway(5000);
              } else {
                this.$toasted.info("Failed to update Page NAme", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-skull-crossbones',
                    after: false
                  }
                })
                    .goAway(5000);
              }

            }
          })
          .catch(error => {
            console.log(error)
          });

      this.savePageNameButtonEnable = true;
      this.savePageNameButtonVariant = "outline-primary";
    },
    saveElectiveChanges: function () {
      let required = this.requiredElective;
      this.$http.put(`vineyard/survey/page/${this.pageId}/elective`, required, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(result => {
            if (result.status === 202) {
              if (result.data) {
                this.$toasted.info("Required Elective Count Saved Successfully", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-save',
                    after: false
                  }
                })
                    .goAway(5000);
              } else {
                this.$toasted.info("Required Elective Count Saved Failed", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-skull-crossbones',
                    after: false
                  }
                })
                    .goAway(5000);
              }

            }
          })
          .catch(error => {
            console.log(error)
          });

      this.saveElectiveButtonEnable = true;
      this.saveElectiveButtonVariant = "outline-primary";
    },
    setSaveable: function () {
      if (this.isMounted++ > 0) {
        console.log("SurveyPageEditor")
        console.log("setSaveable called")
        this.saveButtonEnable = false;
        this.saveButtonVariant = "success";

      }
    },
    setNameSaveable: function () {
      if (this.isMounted++ > 0) {
        console.log("SurveyPageEditor")
        console.log("setNameSaveable called")
        this.savePageNameButtonEnable = false;
        this.savePageNameButtonVariant = "success";

      }
    },
    setElectiveSaveable: function () {
      if (this.isMounted++ > 0) {
        console.log("SurveyPageEditor")
        console.log("setSavable called")
        this.saveElectiveButtonEnable = false;
        this.saveElectiveButtonVariant = "success";

      }
    },
    deleteQuestion: function (questionId, type) {
      console.log("Remove Question");
      let self = this;
      if (type === 'CORE') {
        let questionIndex = this.coreQuestions.findIndex(question => {
          return question._id === questionId
        });
        this.coreQuestions.splice(questionIndex, 1);
        this.coreQuestions.forEach(quest => {
          let questIndex = self.coreQuestions.indexOf(quest);
          quest.qnum = questIndex + 1;
          console.log(quest);
          self.$set(self.coreQuestions, questIndex, quest);
        });
      } else if (type === 'ELECTIVE') {
        let questionIndex = this.electiveQuestions.findIndex(question => {
          return question._id === questionId
        });
        this.electiveQuestions.splice(questionIndex, 1);
        this.electiveQuestions.forEach(this.updateQuestionNumbers);
      }
      this.updateQuestionsOnServer();
    },
    addQuestion: function (questType) {
      let self = this;
      this.questionTypeToAdd = questType;
      this.$http.get(`vineyard/survey/page/${this.pageId}/questions/${questType}`, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => {
        self.pages = response.data;
        this.showFirstModal = true;
      })
          .catch(err => {
            console.log(err);
          })

    },
    addQuestionsToList: function () {
      if (this.questionTypeToAdd === null) {
        alert("Cannot determine question type to add");
        return;
      }
      let newQuestion = {
        _id: this.questionToAdd._id,
        choices: this.questionToAdd.choices,
        colCount: 1,
        columns: this.questionToAdd.columns,
        controlType: this.questionToAdd.controlType,
        creationDate: this.questionToAdd.creationDate,
        greenNote: this.questionToAdd.greenNote,
        hasNone: this.questionToAdd.hasNone,
        name: this.questionToAdd.name,
        qnum: 0,
        section: this.questionToAdd.selectedPage,
        text: this.questionToAdd.text,
        title: this.questionToAdd.title,
        type: this.questionToAdd.type

      }

      if (this.questionTypeToAdd.toLowerCase() === 'core') {
        let sizeOfList = this.coreQuestions.length;
        newQuestion.qnum = sizeOfList + 1;
        this.coreQuestions.push(newQuestion);
      }
      if (this.questionTypeToAdd.toLowerCase() === 'elective') {
        let sizeOfList = this.electiveQuestions.length;
        newQuestion.qnum = sizeOfList + 1;
        this.electiveQuestions.push(newQuestion);
      }
      this.showFirstModal = false;
      this.updateQuestionsOnServer();
      this.selectedPage = null;
    },
    closeModal: function () {
      this.showFirstModal = false;
    },
    getModalRadioStyle: function (optionsList) {
      if (!optionsList) {
        return "font-size: x-large"
      }
      let numbOfOptions = optionsList.length;
      let padding = Math.floor(((100 - (5 * numbOfOptions)) / (numbOfOptions + 1)) / 2);
      return 'padding-left:' + padding + '%; padding-right:' + padding + '%; font-size: 16px;'
    },
    getContrastColor: function (backgroundColor) {
      console.log("Background Color: " + this.pageBackgroundColor);
      //return ColorUtils.getCorrectTextColor(backgroundColor);
      let returnColor = ColorUtils.rgb2hex(this.pageBackgroundColor);
      console.log("Background Color: " + returnColor);
      return ColorUtils.getCorrectTextColor(returnColor);
    }
  }
}
</script>
<style scoped>

.verbiage >>> a:link {
  color: #28763a;
}

.core_measure_header {
  /*color: rgb(222, 119, 43);*/
  color: white;
}

.survey-title {
  font-family: Montserrat, sans-serif, serif;
  padding-top: 15px;
}

/*font-size: 32 px;*/
.page-title {
  margin-left: 5px;
  font-size: 32px;
  font-family: Montserrat, sans-serif;
  text-transform: capitalize;
}

.text-section {
  max-width: 1200px;
  text-align: left;
  margin-left: 5px;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
}

.modal-footer {
  padding: 15px 0 0 0;
  border-top: 1px solid #e5e5e5;
  margin-left: -14px;
  margin-right: -14px;
}

.modal-question-number {
  position: absolute;
  top: 0;
  left: 0;
  margin-right: 5px;
  text-align: right;
}

.modal-question-text {
  padding-left: 10px;
  padding-bottom: 10px;
  margin-left: 10px;
  width: 100%;
  font-size: 20px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  display: inline-block;
}
</style>
